export default {
  title: {
    en: 'Create Your Avatar!',
    ar: 'اصنع شخصيتك'
  },

  description: {
    en: 'Design fun avatars for every family member and get ready for fun challenges!',
    ar: 'صمم شخصيات مرحة لكل فرد من العائلة واستعد لتحديات ممتعة!'
  },

  button: {
    en: 'Okay!',
    ar: 'حسنًا!'
  }
};
